import { Component } from "react"

/* Components */
import { Menu, MobileTab, Header, Background, MainLoading } from "../components"
import PitBoard from "../components/PitBoard"

/* Router */
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"

/* Redux */
import { Provider } from "react-redux"
import { store } from "../store"

/* Helpers */
import { ProtectedRoute } from "../helpers"

/* SOCKET.IO */
import { io } from "socket.io-client"

/* Constants */
import { env, electron } from "../constants"

/* Pages */
import Page404 from "../pages/Page404"
import { Dashboard } from "../pages/Dashboard"
import { Games, MultiGame, VipGame, RouletteGame, VipThreeBox, UltimateThreeHand, NiuNiu, BlackjackGame, PuntoBancoGame, ElectronGame } from "../pages/Game"
import { Dealers } from "../pages/Dealer"
import { Currencies } from "../pages/Currency"
import { Cards } from "../pages/Card"
import { Messages } from "../pages/Message"
import { Transactions } from "../pages/Transaction"
import { Bookings } from "../pages/Booking"
import { Players } from "../pages/Player"
import { Managers } from "../pages/Manager"
import { Operators } from "../pages/Operator"
import { Bonus } from "../pages/Bonus"
import { Studio } from "../pages/Studio"
import { RsgReports, RsgGames } from "../pages/Rsg"
import { Logs } from "../pages/Log"



/* Layout Widget */
class Layout extends Component {

    constructor() {
        super()

        const minimized = localStorage.getItem("minimized")
        const token = localStorage.getItem("token")

        this.state = {
            minimized: minimized && minimized === "yes",
        }

        this.socket = io(env.socketpoint, { auth: { token: `${token}`, type: "admin" } })
    }

    componentWillUnmount = () => {
        this.socket.disconnect()
    }

    /* Toggle Menu */
    toggleMenu = (value) => {

        this.setState({ minimized: value })

        if (value) {
            localStorage.setItem("minimized", "yes")
        }
        else {
            localStorage.removeItem("minimized")
        }

    }


    render = () => {

        /* Fields */
        const { minimized } = this.state
        const { setToken, token } = this.props

        return (
            <Provider store={store}>
                <MainLoading token={token}>
                    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                        <div className="app">

                            <Menu minimized={minimized} toggle={() => this.toggleMenu(!minimized)} />

                            {/* PitBoard — the studio choice of the menu row */}
                            <PitBoard />

                            <div className={`container ${minimized ? "minimized" : "full-container"}`}>

                                <Header socket={this.socket} setToken={setToken} />

                                <Routes>

                                    <Route path="*" element={<ProtectedRoute setToken={setToken}><Page404 /></ProtectedRoute>} />
                                    <Route path="/" element={<ProtectedRoute setToken={setToken}><Dashboard /></ProtectedRoute>} />

                                    {/* Notification — the list and the pause alert live in the header panels */}

                                    {/* RUSSIAN MULTIPOKER */}
                                    <Route path="/table/russian-multipoker/:uid" element={<MultiGame postfix="RMP" />} />

                                    {/* LUNAR MULTIPOKER */}
                                    <Route path="/table/lunar-multipoker/:uid" element={<MultiGame postfix="LMP" />} />

                                    {/* NOVO MULTIPOKER */}
                                    <Route path="/table/novo-multipoker/:uid" element={<MultiGame postfix="NMP" />} />

                                    {/* OPEN MULTIPOKER */}
                                    <Route path="/table/open-multipoker/:uid" element={<MultiGame postfix="OMP" />} />

                                    {/* QUEEN MULTIPOKER */}
                                    <Route path="/table/queen-multipoker/:uid" element={<MultiGame postfix="QMP" />} />

                                    {/* EUROPEAN MULTIPOKER */}
                                    <Route path="/table/european-multipoker/:uid" element={<MultiGame postfix="EMP" />} />

                                    {/* ULTIMATE MULTIPOKER */}
                                    <Route path="/table/ultimate-multipoker/:uid" element={<MultiGame postfix="UMP" />} />

                                    {/* CASINO HOLDEM */}
                                    <Route path="/table/holdem-multipoker/:uid" element={<MultiGame postfix="HMP" />} />

                                    {/* ONE BLACKJACK */}
                                    <Route path="/table/one-blackjack/:uid" element={<BlackjackGame postfix="MOB" />} />

                                    {/* PUNTO BANCO */}
                                    <Route path="/table/punto-banco/:uid" element={<PuntoBancoGame postfix="MPB" />} />

                                    {/* RUSSIAN VIP POKER */}
                                    <Route path="/table/russian-vip-poker/:uid" element={<VipGame postfix="RVP" />} />

                                    {/* RUSSIAN VIP POKER */}
                                    <Route path="/table/queen-vip-poker/:uid" element={<VipGame postfix="QVP" />} />

                                    {/* RUSSIAN VIP POKER */}
                                    <Route path="/table/european-vip-poker/:uid" element={<VipGame postfix="EVP" />} />

                                    {/* ROULETTE 1 */}
                                    <Route path="/table/roulette-1/:uid" element={<RouletteGame postfix="RO1" />} />

                                    {/* VIP ULTIMATE TEXAS HOLD'EM */}
                                    <Route path="/table/vip-ultimate-texas-holdem-vip/:uid" element={<VipThreeBox postfix="UVP" />} />

                                    {/* ULTIMATE TEXAS HOLD'EM 3 BOX — MULTIPLAYER, THE THREE BOXES BELONG TO NOBODY */}
                                    <Route path="/table/ultimate-three-hand-multipoker/:uid" element={<UltimateThreeHand postfix="TUMP" />} />

                                    {/* NIU NIU 3 BOX — MULTIPLAYER, THREE INDEPENDENT STAKES ON EVERY BOX */}
                                    <Route path="/table/niu-niu-multipoker/:uid" element={<NiuNiu postfix="NIU" />} />


                                    {/* ELECTRON GAMES — one page for all of them, see constants/electron */}
                                    {electron.games.map((game) =>
                                        <Route key={game.key} path={`/table/${game.route}/:uid`} element={<ElectronGame game={game} />} />
                                    )}

                                    {/* Game */}
                                    <Route path="/game" element={<ProtectedRoute setToken={setToken}><Games /></ProtectedRoute>} />

                                    {/* Player Routes */}
                                    <Route path="/player" element={<ProtectedRoute setToken={setToken}><Players /></ProtectedRoute>} />
                                    <Route path="/player/:page" element={<ProtectedRoute setToken={setToken}><Players /></ProtectedRoute>} />

                                    {/* Studio Routes */}
                                    <Route path="/studio" element={<ProtectedRoute setToken={setToken}><Studio /></ProtectedRoute>} />
                                    <Route path="/studio/:page" element={<ProtectedRoute setToken={setToken}><Studio /></ProtectedRoute>} />

                                    {/* Bonus Routes */}
                                    <Route path="/bonus" element={<ProtectedRoute setToken={setToken}><Bonus socket={this.socket} /></ProtectedRoute>} />
                                    <Route path="/bonus/:page" element={<ProtectedRoute setToken={setToken}><Bonus socket={this.socket} /></ProtectedRoute>} />

                                    {/* Message Routes */}
                                    <Route path="/message" element={<ProtectedRoute setToken={setToken}><Messages /></ProtectedRoute>} />
                                    <Route path="/message/:page" element={<ProtectedRoute setToken={setToken}><Messages /></ProtectedRoute>} />

                                    {/* Transaction Routes */}
                                    <Route path="/transaction" element={<ProtectedRoute setToken={setToken}><Transactions /></ProtectedRoute>} />
                                    <Route path="/transaction/:page" element={<ProtectedRoute setToken={setToken}><Transactions /></ProtectedRoute>} />

                                    {/* Booking Routes — бронь VIP игр */}
                                    <Route path="/booking" element={<ProtectedRoute setToken={setToken}><Bookings /></ProtectedRoute>} />
                                    <Route path="/booking/:page" element={<ProtectedRoute setToken={setToken}><Bookings /></ProtectedRoute>} />

                                    {/* Card Routes */}
                                    <Route path="/card" element={<ProtectedRoute setToken={setToken}><Cards /></ProtectedRoute>} />

                                    {/* Dealer Routes */}
                                    <Route path="/dealer" element={<ProtectedRoute setToken={setToken}><Dealers /></ProtectedRoute>} />
                                    <Route path="/dealer/:page" element={<ProtectedRoute setToken={setToken}><Dealers /></ProtectedRoute>} />

                                    {/* Currency Routes */}
                                    <Route path="/currency" element={<ProtectedRoute setToken={setToken}><Currencies /></ProtectedRoute>} />
                                    <Route path="/currency/:page" element={<ProtectedRoute setToken={setToken}><Currencies /></ProtectedRoute>} />

                                    {/* Profile — the profile, the password and the login history live in the header panels */}

                                    {/* Manager */}
                                    <Route path="/manager" element={<ProtectedRoute setToken={setToken}><Managers /></ProtectedRoute>} />
                                    <Route path="/manager/:page" element={<ProtectedRoute setToken={setToken}><Managers /></ProtectedRoute>} />

                                    {/* Operator */}
                                    <Route path="/operator" element={<ProtectedRoute setToken={setToken}><Operators /></ProtectedRoute>} />
                                    <Route path="/operator/:page" element={<ProtectedRoute setToken={setToken}><Operators /></ProtectedRoute>} />


                                    {/* RSG Reports */}
                                    <Route path="/rsg" element={<ProtectedRoute setToken={setToken}><RsgReports /></ProtectedRoute>} />
                                    <Route path="/rsg/games" element={<ProtectedRoute setToken={setToken}><RsgGames /></ProtectedRoute>} />
                                    <Route path="/rsg/:page" element={<ProtectedRoute setToken={setToken}><RsgReports /></ProtectedRoute>} />

                                    {/* Logs */}
                                    <Route path="/log" element={<ProtectedRoute setToken={setToken}><Logs /></ProtectedRoute>} />
                                    <Route path="/log/:page" element={<ProtectedRoute setToken={setToken}><Logs /></ProtectedRoute>} />

                                </Routes>

                            </div>

                            <MobileTab />

                        </div>

                        <Background />

                    </Router>
                </MainLoading>
            </Provider>
        )
    }

}

export default Layout